module.exports = __webpack_public_path__ + "static/media/background_print.f36ec553.png";